<template>
  <div class="container has-text-centered">
    <section class="hero is-fullheight">
      <div class="hero-body has-text-centered">
        <div class="login">
          <!-- <img style="padding: 10px" src="../assets/medprep.png" width="325px" /> -->
          <h2 class="forgot-password">Forgot Passsword?</h2>
          <p>You can reset your password here.</p>
          <div style="margin-top: 30px"></div>

          <form>
            <div class="field">
              <div class="control">
                <input
                  class="input is-medium is-rounded"
                  type="email"
                  v-model="form.email"
                  @blur="$v.form.email.$touch()"
                  placeholder="admin@example.com"
                  autocomplete="username"
                />

                <div v-if="$v.form.email.$error" class="form-error">
                  <span v-if="!$v.form.email.required" class="help is-danger">Email is Required</span>
                  <span
                    v-if="!$v.form.email.email"
                    class="help is-danger"
                  >Email Address is not Valid</span>
                </div>
              </div>
            </div>

            <button
              class="button is-block is-fullwidth is-primary is-medium is-rounded"
              @click.prevent="resetPassword"
              :disabled="isFormInvalid"
            >
              <b-icon
                pack="fas"
                icon="sync-alt"
                :custom-size="[{ 'fa-lg': isLoading }]"
                :custom-class="[{ 'fa-spin': isLoading }]"
              ></b-icon>
              <span style="margin-left: 15px;
              ">Reset Password</span>
            </button>
          </form>
          <br />
          <nav class="level">
            <div class="level-item has-text-centered">
              <div>
                <router-link to="/login">
                  <a>Have access to your account? Back to Login</a>
                </router-link>
              </div>
            </div>
            <!-- <div class="level-item has-text-centered">
              <div>
                <a href="#">Create an Account</a>
              </div>
            </div>-->
          </nav>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
export default {
  data() {
    return {
      form: {
        email: '',
      },
      isLoading: false,
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  computed: {
    isFormInvalid() {
      return this.$v.form.$invalid;
    },
  },
  methods: {
    resetPassword() {
      this.isLoading = true;
      this.$v.form.$touch();

      this.$store
        .dispatch('auth/resetPassword', this.form)
        .then(() => {
          this.form.email = '';
          this.isLoading = false;
          this.$buefy.snackbar.open({
            message: `Password was Reset Successfully. Please access your reset link in your email address.`,
            queue: false,
          });
        })
        .catch((errMessage) => {
          // console.log(errMessage);
          this.$buefy.snackbar.open({
            message: `Failed to Reset Password ${errMessage}`,
            queue: false,
          });
          this.isLoading = false;
        });
    },
  },
};
</script>



<style scoped>
.forgot-password {
  font-size: xx-large;
}

.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}
.avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

@media screen and (min-width: 1024px) {
  .container {
    padding-right: 12rem;
  }
}

.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
/* .box {
  margin-top: 5rem;
} */
/* .avatar {
  margin-top: -70px;
  padding-bottom: 20px;
} */
/* .avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
} */
/* input {
  font-weight: 300;
} */
/* p {
  font-weight: 700;
} */
/* p.subtitle {
  padding-top: 1rem;
} */

/* .login-hr {
  border-bottom: 1px solid black;
} */

/* .has-text-black {
  color: black;
} */

/* .field {
  padding-bottom: 10px;
} */
/* 
.fa {
  margin-left: 5px;
} */
/* 
* {
  font-family: 'Nunito Sans', sans-serif;
} */

.hero-body {
  justify-content: center;
}

.login {
  border-radius: 25px;
  padding: 1.5rem;
  box-shadow: 2px 2px 2px #0372bb, -2px -2px 4px #0372bb;
}

.background {
  background-color: #1d1e21;
}

a {
  font-weight: 600;
}

.button.is-primary {
  background-color: #0372bb;
  border-color: transparent;
  color: #fff;
}
</style>
